// src/services/personnelService.js
import api from './api';

// Get all personnel
export const getAllPersonnel = async (filters = {}) => {
  const params = new URLSearchParams(filters);
  const response = await api.get(`/personnel?${params}`);
  return response.data;
};

// Get single personnel
export const getPersonnelById = async (id) => {
  const response = await api.get(`/personnel/${id}`);
  return response.data;
};

// Search personnel
export const searchPersonnel = async (query, commandId) => {
  const response = await api.get(`/personnel/search/${query}?commandId=${commandId}`);
  return response.data;
};

// Create personnel (single)
export const createPersonnel = async (personnelData) => {
  const response = await api.post('/personnel', personnelData);
  return response.data;
};

// Update personnel
export const updatePersonnel = async (id, personnelData) => {
  const response = await api.put(`/personnel/${id}`, personnelData);
  return response.data;
};

// Delete personnel
export const deletePersonnel = async (id) => {
  const response = await api.delete(`/personnel/${id}`);
  return response.data;
};

// Pre-clear personnel
export const preClearPersonnel = async (id) => {
  const response = await api.post(`/personnel/${id}/pre-clear`);
  return response.data;
};

// Remove pre-clearance
export const removePreClearance = async (id) => {
  const response = await api.delete(`/personnel/${id}/pre-clear`);
  return response.data;
};

// Validate CSV data
export const validateCSVData = async (data, commandId) => {
  const response = await api.post('/upload/validate', { data, commandId });
  return response.data;
};

// Bulk upload personnel
export const bulkUploadPersonnel = async (data, commandId) => {
  const response = await api.post('/upload/personnel', { data, commandId });
  return response.data;
};